export default "__VITE_ASSET__50d8e507__"